/**
 * User's selected intent on the Property Details Page.
 * Stored separately from offerType and persisted to the backend on badge click.
 */
export enum Intent {
  Inform = 'inform',
  Selling = 'selling',
  Buying = 'buying',
  Rental = 'rental',
  Financing = 'financing',
}

export const INTENT_ORDER: Intent[] = [
  Intent.Inform,
  Intent.Selling,
  Intent.Buying,
  Intent.Rental,
  Intent.Financing,
];
